import { forwardRef, useState } from 'react';
import ProjectCard from '../ProjectCard/ProjectCard';
import styles from './Projects.module.css';
import Loading from '../Loading/Loading';
import { useFetch } from '../../hooks/useFetch';
import { getAuthContext } from '../../context/AuthContext';
import FormModal from '../FormModal/FormModal';
import type { Project } from '../../../shared/types';

const Projects = forwardRef<HTMLElement>((_props, ref) => {
  const [refreshCount, setRefreshCount] = useState(0);
  const handleRefreshGrid = () => setRefreshCount((prev) => prev + 1);

  const { user, isLoading: isAuthLoading } = getAuthContext();

  const url = `${import.meta.env.VITE_BASE_URL || 'https://mellem.dev'}/api/v1/get/projects`;
  const { data, error, isLoading } = useFetch<Project[]>(url, refreshCount);

  return (
    <section className={styles.section} id="projects" ref={ref}>
      <div className={styles.header}>
        <h2 className={styles.title}>Projects</h2>
        {user && !isAuthLoading && <FormModal onSucessfullSubmit={handleRefreshGrid} />}
      </div>
      <div className={styles.projectsContainer}>
        {isLoading && <Loading />}
        {error && <p className={styles.error}>Error: {error}</p>}
        {data &&
          data.map((project) => (
            <ProjectCard data={project} onSucessfullSubmit={handleRefreshGrid} key={project.id} />
          ))}
      </div>
    </section>
  );
});

Projects.displayName = 'Projects';

export default Projects;

